//DON'T PUT ANYTHING IN THIS FILE EXCEPT THE KEY IDS!!!!!!!!!!!

export const InternalPartCostOnRO = 196;

export const TechnicianMaxROs = 230;
export const TechnicianAutoStopTime = 231;
export const TechnicianAutoStopTimeEnabled = 256;

export const ServiceAppointmentHoursStart = 232;
export const ServiceAppointmentHoursEnd = 233;
export const ServiceHasMaxAppointments = 234;
export const ServiceMaxAppointmentsInterval = 235;
export const ServiceMaxAppointmentsCount = 236;

export const QuickLubeAppointmentHoursStart = 237;
export const QuickLubeAppointmentHoursEnd = 238;
export const QuickLubeHasMaxAppointments = 239;
export const QuickLubeMaxAppointmentsInterval = 240;
export const QuickLubeMaxAppointmentsCount = 241;

export const BodyShopAppointmentHoursStart = 242;
export const BodyShopAppointmentHoursEnd = 243;
export const BodyShopHasMaxAppointments = 244;
export const BodyShopMaxAppointmentsInterval = 245;
export const BodyShopMaxAppointmentsCount = 246;

export const AllDeptsAppointmentHoursStart = 249;
export const AllDeptsAppointmentHoursEnd = 250;
export const AllDeptsHasMaxAppointments = 251;
export const AllDeptsMaxAppointmentsInterval = 252;
export const AllDeptsMaxAppointmentsCount = 253;

export const PrintTechCommentsWarrantyRecap = 255;
export const WOPrintLaborHours = 301;
export const SetApptParameters = 303;

export const DefaultApptAdvisor = 167;
export const RequireAppointmentAdvisor = 168;

export const DispatchServiceUseDefaultScore = 257;
export const DispatchServicePriorityStatusYes = 258;
export const DispatchServicePriorityStatusWaiting = 259;
export const DispatchServiceTransportationLoaner = 260;
export const DispatchServiceTransportationRental = 261;
export const DispatchServiceTransportationShuttle = 262;
export const DispatchServiceLoanerPremiumPickup = 263;
export const DispatchServicePremiumPickup = 264;
export const DispatchServiceArrivalPickup = 265;
export const DispatchServiceCarryOver = 266;
export const DispatchServiceRecheck = 267;
export const DispatchServiceAppointment = 268;
export const DispatchQuickLubeUseServiceSettings = 269;
export const DispatchQuickLubeUseDefaultScore = 270;
export const DispatchQuickLubePriorityStatusYes = 271;
export const DispatchQuickLubePriorityStatusWaiting = 272;
export const DispatchQuickLubeTransportationLoaner = 273;
export const DispatchQuickLubeTransportationRental = 274;
export const DispatchQuickLubeTransportationShuttle = 275;
export const DispatchQuickLubeLoanerPremiumPickup = 276;
export const DispatchQuickLubePremiumPickup = 277;
export const DispatchQuickLubeArrivalPickup = 278;
export const DispatchQuickLubeCarryOver = 279;
export const DispatchQuickLubeRecheck = 280;
export const DispatchQuickLubeAppointment = 281;
export const DispatchBodyShopUseServiceSettings = 282;
export const DispatchBodyShopUseDefaultScore = 283;
export const DispatchBodyShopPriorityStatusYes = 284;
export const DispatchBodyShopPriorityStatusWaiting = 285;
export const DispatchBodyShopTransportationLoaner = 286;
export const DispatchBodyShopTransportationRental = 287;
export const DispatchBodyShopTransportationShuttle = 288;
export const DispatchBodyShopLoanerPremiumPickup = 289;
export const DispatchBodyShopPremiumPickup = 290;
export const DispatchBodyShopArrivalPickup = 291;
export const DispatchBodyShopCarryOver = 292;
export const DispatchBodyShopRecheck = 293;
export const DispatchBodyShopAppointment = 294;
export const DispatchServicePickup = 295;
export const DispatchServiceValet = 296;
export const DispatchQuickLubePickup = 297;
export const DispatchQuickLubeValet = 298;
export const DispatchBodyShopPickup = 299;
export const DispatchBodyShopValet = 300;

export const IncludeLaborCostRate = 306;

export const OilChangeLine1 = 312;
export const OilChangeLine2 = 313;
export const OilChangeLine3 = 314;
export const OilChangeLine4 = 315;
export const OilChangeMonthsValue = 316;
export const OilChangeMilesValue = 317;
export const OilChangeMonthsLabel = 318;
export const OilChangeMilesLabel = 319;
export const WOAdditionalLines = 320;
export const ShowCustomerComments = 322;
export const TechnicianFilterByDepartment = 324;
export const HideFixedCost = 325;
export const LaborRateCalculationPerLaborLine = 326;
export const WorkOrderROComments = 327;
export const ApptInspection = 328;

//DON'T PUT ANYTHING IN THIS FILE EXCEPT THE KEY IDS!!!!!!!!!!!
